import {Operation} from "./Operation.js";


export class Median extends Operation {

    static displayName() {
        return "Median";
    }

    static isNumeric() {
        return true;
    }

    static isCategorical() {
        return false;
    }

    static handlesDate() {
        return true; // Median can be applied to dates as well
    }

    incrementAggregation(newValue) {
        if (this.currValue === null) {
            this.currValue = []
        }
        this.currValue.push(newValue || 0);
    }

    finish(globalAggregation) {
        if (this.currValue === null || this.currValue.length === 0) {
            return 0; // or handle as needed
        }
        const middle = Math.floor(this.currValue.length / 2);
        this.currValue.sort((a, b) => a - b);
        if (this.currValue.length % 2 === 0) {
            return (this.currValue[middle - 1] + this.currValue[middle]) / 2;
        } else {
            return this.currValue[middle];
        }
    }
}


export default Median;